export default __webpack_public_path__ + "static/media/spin.75249709.svg";